import React from 'react';
import { StyledLink } from './styled';

export type LinkProps = React.ComponentProps<typeof StyledLink>;

export const LinkDeprecated = StyledLink;
